export interface OrganizationCapabilities {
  payroll: boolean;
  companiesHouseSearch: boolean;
  customHolidayCalendar: boolean;
  ukStatutoryDocuments: boolean;
}

export interface OrganizationCountryMetadata {
  organizationCountryCode?: string | null;
  currencyCode?: string | null;
  locale?: string | null;
  timeZoneId?: string | null;
  capabilities?: OrganizationCapabilities | null;
}

export interface SupportedCountry extends OrganizationCountryMetadata {
  countryCode: string;
  name: string;
  dialCode: string;
  currencyCode: string;
  locale: string;
  timeZoneId: string;
  capabilities: OrganizationCapabilities;
}

export const DEFAULT_COUNTRY_CODE = "GB";
export const DEFAULT_CURRENCY_CODE = "GBP";

export function hasOrganizationCapability(
  metadata: OrganizationCountryMetadata | undefined | null,
  capability: keyof OrganizationCapabilities,
): boolean {
  return metadata?.capabilities?.[capability] ?? true;
}

export function organizationCurrencyCode(
  metadata: OrganizationCountryMetadata | undefined | null,
): string {
  return metadata?.currencyCode || DEFAULT_CURRENCY_CODE;
}

export function normalizeCountryCode(value?: string | null): string | undefined {
  if (!value) return undefined;

  const normalized = value.trim().toUpperCase();
  if (!normalized) return undefined;

  if ([
    "UK",
    "U.K",
    "U.K.",
    "GREAT BRITAIN",
    "BRITAIN",
    "UNITED KINGDOM",
    "ENGLAND",
    "WALES",
    "SCOTLAND",
    "NORTHERN IRELAND",
  ].includes(normalized)) {
    return DEFAULT_COUNTRY_CODE;
  }

  return normalized.length === 2 ? normalized : undefined;
}
